import { CommonPatientResponse } from '@/api/services/common/patient/common-patient.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { IdentifierTypeResponse } from '@/api/resources/common/initialization/common-initialization.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'

export interface BillingModalCustomerSelectionParams {
    patient: CommonPatientResponse
}

export interface BillingModalCustomerSelectionState {
    patient: StrictNullable<CommonPatientResponse>
    customers: CustomerResponse[]
    identifierType: Nullable<IdentifierTypeResponse>
}
export const initialBillingModalCustomerSelectionState =
    (): BillingModalCustomerSelectionState => ({
        patient: null,
        customers: [],
        identifierType: null
    })
